let constant = {
  minPageWidth: 1350
}
export default constant